import { Controller } from "stimulus"
import $ from 'jquery';

export default class extends Controller {
  static targets = ['icon', 'resource']

  handleCollapse() {
    this.handleCollapseIcon()
    this.handleViewableContent()
  }

  handleViewableContent() {
    if ($('#content').hasClass('visually-hidden')) {
      this.show('#content')
      this.hide('#truncated-content')
    } else {
      this.hide('#content')
      this.show('#truncated-content')
    }
  }

  handleCollapseIcon() {
    $(this.iconTarget).toggleClass('expanded')
  }

  getData() {
    if ($(this.iconTarget).hasClass('expanded')) {
      const url = this.resourceTarget.dataset.url

      $.get({
        dataType: 'script',
        url: `${url}/${this.resourceTarget.dataset.id}`
      })
    }
  }

  hide(target) {
    $(target).addClass('visually-hidden')
  }

  show(target) {
    $(target).removeClass('visually-hidden')
  }
}